module.exports = __webpack_public_path__ + "static/media/home.a5118c8b.svg";